// Port of api/fuel/app/classes/insights/size/hotness.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function safeDivide(total, count, digits) {
	if (!count) return 0
	var value = total / count
	var power = Math.pow(10, digits || 0)
	return Math.round(value * power) / power
}

export default Segment.extend({
	name: 'hotness',
	types: [Constants.TYPE_USER],
	enabled: false,
	insight: false,
	detail: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var hotness = {}
		var hotIndex = []
		var candidates = Util.queryFast(
			'SELECT l.log_id AS l, l.game_id AS g, c.game_version_id AS v, g.game_name AS n,' +
			' v.game_version_name AS vn, g.game_rank AS r, c.collection_own AS o, l.log_date AS d,' +
			' c.collection_date_owned AS do, g.game_published AS dg, v.game_version_year AS dv,' +
			' v.game_version_date_release AS vr, v.game_version_kickstarter AS vk' +
			' FROM (log_user_collection l LEFT JOIN collection c ON c.game_id = l.game_id AND c.user_id = l.user_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id, game g' +
			' WHERE l.log_context = ' + Constants.LOG_CONTEXT_ADDED +
			' AND g.game_type = 1 AND l.game_id = g.game_id AND l.user_id = ' + owner.get_id()
		)

		for (var i = 0; i < candidates.length; i++) {
			var candidate = candidates[i]
			var dateReleased = Util.mktime(0, 0, 0, [1, 7, parseInt(candidate.dg, 10) || 1970])
			var dateOwned = parseInt(candidate.do, 10) || parseInt(candidate.d, 10) || 0
			var hasVersion = parseInt(candidate.v, 10) || 0
			if (hasVersion) {
				dateReleased = parseInt(candidate.vr, 10) || Util.mktime(0, 0, 0, [1, 7, parseInt(candidate.dv, 10) || parseInt(candidate.dg, 10) || 1970])
			}

			var timeLapsed = Math.abs(dateOwned - dateReleased)
			var rank = parseInt(candidate.r, 10) || 0
			var versionYear = parseInt(candidate.dv, 10) || 0
			var publishYear = parseInt(candidate.dg, 10) || 0

			if (rank < 1000 && rank > 0 && timeLapsed < (Constants.TIME_DAY * 360) && (!hasVersion || versionYear - publishYear <= 1 || parseInt(candidate.vk, 10))) {
				var daysLapsed = Math.ceil(timeLapsed / Constants.TIME_DAY)
				var owners = parseInt(candidate.o, 10) || 0
				var score = (Math.ceil(owners / 1000) + Math.ceil((1000 - rank) / 100)) * Math.ceil(daysLapsed / 360)
				var heat = Math.ceil(score / 15)
				if (heat > 3) heat = 3

				hotness[parseInt(candidate.l, 10)] = {
					id: parseInt(candidate.g, 10),
					name: candidate.n,
					version: candidate.vn,
					rank: rank,
					owners: owners,
					owned: dateOwned,
					released: dateReleased,
					days: daysLapsed,
					score: score,
					heat: heat
				}
				hotIndex.push(parseInt(candidate.g, 10))
			}
		}

		var hotnessList = Object.keys(hotness).map(function(key) { return hotness[key] })
		var games = Util.sort_by_field(hotnessList, 'owned', 'desc').slice(0, 5)
		for (var g = 0; g < games.length; g++) this._references.games.push(games[g].id)

		var collectionRows = Util.queryFast(
			'SELECT game_id FROM collection WHERE user_id = ' + owner.get_id() +
			' AND collection_own = 1 AND collection_expansion = 0'
		)
		var collectionIndex = collectionRows.map(function(row) { return parseInt(row.game_id, 10) }).filter(Boolean)
		var collectionSet = {}
		for (var cs = 0; cs < collectionIndex.length; cs++) collectionSet[collectionIndex[cs]] = true

		var currentCount = 0
		for (var hi = 0; hi < hotIndex.length; hi++) if (collectionSet[hotIndex[hi]]) currentCount++

		var addedCount = 0
		var otherCount = 0
		var playsHot = 0
		var playsOther = 0
		var playsHotBefore = 0
		var playsOtherBefore = 0
		var lifespanHot = { count: 0, days: 0 }
		var lifespanOther = { count: 0, days: 0 }
		var ratingHot = { count: 0, value: 0 }
		var ratingOther = { count: 0, value: 0 }
		var trend = []
		var trendRaw = []

		var all = Util.queryFast(
			'SELECT l.log_id AS l, g.game_name AS n, l.game_id AS g, l.log_date AS d, c.collection_date_owned AS do' +
			' FROM (log_user_collection l LEFT JOIN collection c ON c.game_id = l.game_id AND c.user_id = l.user_id), game g' +
			' WHERE l.log_context = ' + Constants.LOG_CONTEXT_ADDED +
			' AND g.game_type = 1 AND l.game_id = g.game_id AND l.user_id = ' + owner.get_id() +
			' ORDER BY l.log_date ASC'
		)
		var allGames = all.map(function(item) { return parseInt(item.g, 10) }).filter(Boolean)
		var playDates = {}
		var playRatings = {}
		var playRemoved = {}

		if (allGames.length) {
			var playDateRows = Util.queryFast(
				'SELECT play_date AS d, game_id AS g FROM play WHERE game_id IN(' + Util.in(allGames) + ')' +
				' AND user_id = ' + owner.get_id() + ' ORDER BY game_id ASC, play_date ASC'
			)
			for (var pd = 0; pd < playDateRows.length; pd++) {
				var pdGame = parseInt(playDateRows[pd].g, 10)
				if (!playDates[pdGame]) playDates[pdGame] = []
				playDates[pdGame].push(parseInt(playDateRows[pd].d, 10) || 0)
			}

			var ratingRows = Util.queryFast(
				'SELECT rating_value AS r, game_id AS g FROM rating WHERE game_id IN(' + Util.in(allGames) + ')' +
				' AND user_id = ' + owner.get_id()
			)
			for (var rr = 0; rr < ratingRows.length; rr++) playRatings[parseInt(ratingRows[rr].g, 10)] = parseFloat(ratingRows[rr].r) || 0

			var removedRows = Util.queryFast(
				'SELECT log_date AS d, game_id AS g FROM log_user_collection_status WHERE game_id IN(' + Util.in(allGames) + ')' +
				' AND user_id = ' + owner.get_id() + ' AND log_context = ' + Constants.LOG_CONTEXT_REMOVED +
				' ORDER BY game_id ASC, log_date ASC'
			)
			for (var pr = 0; pr < removedRows.length; pr++) {
				var prGame = parseInt(removedRows[pr].g, 10)
				if (!playRemoved[prGame]) playRemoved[prGame] = []
				playRemoved[prGame].push(parseInt(removedRows[pr].d, 10) || 0)
			}
		}

		var hotSet = {}
		for (var hs = 0; hs < hotIndex.length; hs++) hotSet[hotIndex[hs]] = true

		for (var a = 0; a < all.length; a++) {
			var item = all[a]
			var gameId = parseInt(item.g, 10)
			var isHot = !!hotSet[gameId]
			addedCount++

			var date = parseInt(item.do, 10) || parseInt(item.d, 10) || 0
			var plays = 0
			var playsBefore = 0
			var dates = playDates[gameId] || []
			for (var di = 0; di < dates.length; di++) {
				if (dates[di] < date) playsBefore++
				else if (dates[di] >= date) plays++
			}

			if (isHot) {
				playsHot += plays
				playsHotBefore += playsBefore
			} else {
				otherCount++
				playsOther += plays
				playsOtherBefore += playsBefore
			}

			var removedDates = playRemoved[gameId] || []
			var removed = false
			for (var rd = 0; rd < removedDates.length; rd++) {
				if (removedDates[rd] > parseInt(item.d, 10)) {
					removed = removedDates[rd]
					break
				}
			}

			if (removed) {
				if (isHot) {
					lifespanHot.count++
					lifespanHot.days += Math.ceil((removed - parseInt(item.d, 10)) / Constants.TIME_DAY)
				} else {
					lifespanOther.count++
					lifespanOther.days += Math.ceil((removed - parseInt(item.d, 10)) / Constants.TIME_DAY)
				}
			}

			if (playRatings[gameId] !== undefined) {
				if (isHot) {
					ratingHot.count++
					ratingHot.value += playRatings[gameId]
				} else {
					ratingOther.count++
					ratingOther.value += playRatings[gameId]
				}
			}

			trendRaw.push(isHot ? 1 : 0)
		}

		var currentHotCount = 0
		for (var chi = 0; chi < hotIndex.length; chi++) if (collectionSet[hotIndex[chi]]) currentHotCount++

		if (trendRaw.length) {
			var trendBars = Math.floor(trendRaw.length / 10)
			var trendSize
			var trendFirstSize
			if (trendBars > 10) {
				trendSize = Math.floor(trendRaw.length / 10)
				trendFirstSize = trendRaw.length - (trendSize * 10)
				trendBars = 10
			} else if (trendBars > 0) {
				trendSize = Math.floor(trendRaw.length / trendBars)
				trendFirstSize = trendRaw.length % trendSize
			} else {
				trendBars = 1
				trendSize = trendRaw.length
				trendFirstSize = 0
			}

			var index = 0
			for (var b = 1; b <= trendBars; b++) {
				trend[b - 1] = 0
				var barSize = (b === 1) ? trendSize + trendFirstSize : trendSize
				var precedingSize = (b === 1) ? 0 : ((b - 1) * trendSize) + trendFirstSize
				for (var ti = index; ti < index + barSize; ti++) trend[b - 1] += trendRaw[ti]
				index += barSize
				if (b > 1) trend[b - 1] = Math.round((((trend[b - 2] * precedingSize) + trend[b - 1]) / (precedingSize + barSize)) * 10) / 10
				else trend[b - 1] = Math.round((trend[b - 1] / barSize) * 10) / 10
			}
		}

		var overview = {
			score: trend.length ? trend[trend.length - 1] : 0,
			trend: trend,
			additions: {
				all: hotIndex.length,
				current: currentHotCount
			},
			collection: {
				all: addedCount ? (100 / addedCount) * hotIndex.length : 0,
				current: collectionIndex.length ? (100 / collectionIndex.length) * currentCount : 0
			},
			plays: {
				hot: safeDivide(playsHot, hotIndex.length, 1),
				other: safeDivide(playsOther, collectionIndex.length, 1)
			},
			preplayed: {
				hot: safeDivide(playsHotBefore, hotIndex.length, 1),
				other: safeDivide(playsOtherBefore, collectionIndex.length, 1)
			},
			retention: {
				hot: hotIndex.length ? (100 / hotIndex.length) * currentHotCount : 0,
				other: otherCount ? (100 / otherCount) * (collectionIndex.length - currentHotCount) : 0
			},
			lifespan: {
				hot: lifespanHot.count ? Math.ceil(lifespanHot.days / lifespanHot.count) : 0,
				other: lifespanOther.count ? Math.ceil(lifespanOther.days / lifespanOther.count) : 0
			},
			rating: {
				hot: ratingHot.count ? Math.round((ratingHot.value / ratingHot.count) * 10) / 10 : 0,
				other: ratingOther.count ? Math.round((ratingOther.value / ratingOther.count) * 10) / 10 : 0
			}
		}

		return {
			hotness: {
				overview: overview,
				games: games
			}
		}
	}
})
